import { isNil, isNotNil } from "ramda";
import { maybe } from "shared/maybe";
export function labelProcedurePrintData(data) {
    const parts = [
        data.asset.location.name,
        " / ", //TODO replace w config var
        data.asset.name,
        maybe(data.procedure.type?.name, _ => " (" + _ + ")", () => "")
    ];
    return parts.filter(_ => _ !== "").join("").replaceAll(/\s*\/\s*/g, " - ");
}
export function validateProcedurePrintData(data) {
    const errorArrays = [
        data.asset.photo === null ? ["Asset has no photo."] : [],
        data.asset.photo?.present === false ? ["Asset's photo has not been synced yet. Please try again."] : [],
        data.procedure.controlPoints.length === 0 ? ["Procedure has no control points."] : [],
        data.procedure.controlPoints.filter(_ => _.number === "0").map(controlPoint => "Control point #" + controlPoint.step + " has a number of 0."),
        data.procedure.controlPoints.filter(_ => isNil(_.photo)).map(controlPoint => "Control point " + controlPoint.energySource.prefix + "-" + controlPoint.number + " has no photo."),
        data.procedure.controlPoints.filter(_ => _.photo?.present === false).map(controlPoint => "Control point " + controlPoint.energySource.prefix + "-" + controlPoint.number + "'s photo has not been synced yet. Please try again."),
        data.procedure.hazards.filter(_ => _.icon?.present === false).map(hazard => "Hazard " + hazard.name + "'s photo has not been synced yet. Please try again."),
        data.procedure.controlPoints.map(_ => _.energySource).filter(_ => _.icon?.present === false).map(energySource => "Energy source " + energySource.name + "'s photo has not been synced yet. Please try again."),
        data.procedure.controlPoints.map(_ => _.isolationDevice).filter(_ => _.icon?.present === false).map(isolationDevice => "Isolation device " + isolationDevice.name + "'s photo has not been synced yet. Please try again."),
    ];
    return errorArrays.flat().filter(isNotNil);
}
